<template>
  <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0V7.5H0V21H6V36H27L36 27V0H6ZM1.5 19.5V9H24V19.5H1.5ZM27 33.879V27H33.879L27 33.879ZM34.5 25.5H25.5V34.5H7.5V21H25.5V7.5H7.5V1.5H34.5V25.5Z" fill="currentColor"/>
    <path d="M7.30342 14.2261L8.79592 11.0491H7.38442L6.56542 13.1281L5.73742 11.0491H4.30642L5.78092 14.2261L4.18042 17.4751H5.60092L6.52042 15.2971L7.44742 17.4751H8.90392L7.30342 14.2261Z" fill="currentColor"/>
    <path d="M13.7656 11.0491L12.8386 15.5851H12.8206L11.9026 11.0491H9.9751V17.4751H11.1631V12.3451H11.1811L12.3241 17.4751H13.3321L14.4751 12.3451H14.4946V17.4751H15.6826V11.0491H13.7656Z" fill="currentColor"/>
    <path d="M18.4455 16.4131V11.0491H17.1479V17.4751H20.739V16.4131H18.4455Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
name: "IconFileXml"
}
</script>

<style scoped>

</style>